import { useEffect, useState } from 'react';
import { catalogApi } from '../api';

// Kaskádový výběr kategorie → podkategorie → typ položky, s možností vlastní položky.
// Volá onSelect({ type: 'catalog', itemType }) nebo ({ type: 'custom', custom_category_id }).
export default function CatalogPicker({ value, onSelect }) {
  const [tree, setTree] = useState([]);
  const [custom, setCustom] = useState(value?.type === 'custom');
  const [catId, setCatId] = useState('');
  const [subId, setSubId] = useState('');
  const [typeId, setTypeId] = useState(value?.itemType?.id || '');

  useEffect(() => { catalogApi.tree().then((r) => setTree(r.data)).catch(() => {}); }, []);

  const cat = tree.find((c) => c.id === catId);
  const sub = cat?.subcategories.find((s) => s.id === subId);

  const pickType = (id) => {
    setTypeId(id);
    const t = sub?.item_types.find((it) => it.id === id);
    if (t) onSelect({ type: 'catalog', itemType: t });
  };

  return (
    <div>
      <div className="flex gap-8" style={{ marginBottom: 8 }}>
        <button type="button" className={`btn btn-sm ${!custom ? 'btn-primary' : 'btn-outline'}`}
          onClick={() => { setCustom(false); onSelect(null); }}>Z katalogu</button>
        <button type="button" className={`btn btn-sm ${custom ? 'btn-primary' : 'btn-outline'}`}
          onClick={() => { setCustom(true); onSelect({ type: 'custom', custom_category_id: catId || null }); }}>Vlastní položka</button>
      </div>

      {!custom ? (
        <>
          <div className="form-group">
            <label>Kategorie</label>
            <select className="form-input" value={catId} onChange={(e) => { setCatId(e.target.value); setSubId(''); setTypeId(''); }}>
              <option value="">— vyberte —</option>
              {tree.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </div>
          {cat && (
            <div className="form-group">
              <label>Podkategorie</label>
              <select className="form-input" value={subId} onChange={(e) => { setSubId(e.target.value); setTypeId(''); }}>
                <option value="">— vyberte —</option>
                {cat.subcategories.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
              </select>
            </div>
          )}
          {sub && (
            <div className="form-group">
              <label>Typ položky</label>
              <select className="form-input" value={typeId} onChange={(e) => pickType(e.target.value)}>
                <option value="">— vyberte —</option>
                {sub.item_types.map((it) => <option key={it.id} value={it.id}>{it.name} ({it.unit})</option>)}
              </select>
            </div>
          )}
          {sub && sub.item_types.length === 0 && (
            <p className="text-muted" style={{ fontSize: '0.8rem' }}>V této podkategorii zatím nejsou typy položek.</p>
          )}
        </>
      ) : (
        <div className="form-group">
          <label>Kategorie vlastní položky <span className="text-muted">(volitelné)</span></label>
          <select className="form-input" value={catId}
            onChange={(e) => { setCatId(e.target.value); onSelect({ type: 'custom', custom_category_id: e.target.value || null }); }}>
            <option value="">— bez kategorie —</option>
            {tree.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
        </div>
      )}
    </div>
  );
}
